module.exports = __webpack_public_path__ + "img/mine.9052ab8c.png";